class HomeBlockBot {
    /**
     * Constructor
     */
    constructor() {
        /**
         * @type {HTMLElement}
         */
        this.overlayBlockLeft = document.getElementById('overlay-block-home-left');
        /**
         * @type {HTMLElement}
         */
        this.overlayBlockRight = document.getElementById('overlay-block-home-right');

        /**
         * Init animation
         */
        this._animation();

    }

    /**
     * Animation
     * @private
     */
    _animation() {
        // Block left bottom
        this.overlayBlockLeft.classList.add('height');

        // Block right bottom
        setTimeout(() => {
            this.overlayBlockRight.classList.add('height');
        }, 150);
    }
}